import ApiService from './ApiService';
import {
  detailSearchParams,
  mapDetailPage,
  mapSummary,
  summarySearchParams,
} from './assignmentReportQuery';

class WebcontactService {
  static async getOrigins() {
    const url = '/api3/webcontact_rules/origins/';
    const response = await ApiService.get(url);
    return response;
  }

  static async getAssignmentRules() {
    const url = '/api3/webcontact_rules/rules/';
    const response = await ApiService.get(url);
    return response;
  }

  static async getAssignmentRule(ruleId) {
    const url = `/api3/webcontact_rules/rules/${ruleId}/`;
    const response = await ApiService.get(url);
    return response;
  }

  static async getAssignmentRulesSummary() {
    const url = `/api3/webcontact_rules/rules/summary/`;
    const response = await ApiService.get(url);
    return response;
  }

  static async getAssignmentRulesOptions() {
    const url = '/api3/webcontact_rules/rules/options/';
    const response = await ApiService.get(url);
    return response;
  }

  static async getAssignmentLimits() {
    const url = '/api3/webcontact_rules/limits/';
    const response = await ApiService.get(url);
    return response;
  }

  static async updateAssignmentLimits(partial) {
    const url = '/api3/webcontact_rules/limits/';
    const response = await ApiService.patch(url, partial, undefined, false, {
      keepalive: true,
    });
    return response;
  }

  static async deletAssignmenteRule(ruleId) {
    const url = `/api3/webcontact_rules/rules/${ruleId}/`;
    const response = await ApiService.delete(url);
    return response;
  }

  static async createAssignmentRule(ruleData) {
    const url = '/api3/webcontact_rules/rules/';
    const response = await ApiService.post(url, ruleData);
    return response;
  }

  static async updateAssignmentRule(ruleId, ruleData) {
    const url = `/api3/webcontact_rules/rules/${ruleId}/`;
    const response = await ApiService.put(url, ruleData);
    return response;
  }

  static async getDevelopmentRules() {
    const url = `/api3/webcontact_rules/development-rules/?page=1&page_size=20`;
    const response = await ApiService.get(url);
    return response;
  }

  static async updateOrder(idsArray) {
    const url = `/api3/webcontact_rules/rules/order/`;
    const data = { order: idsArray };
    const response = await ApiService.put(url, data);
    return response;
  }

  static async requestWebcontactRulesUpgrade() {
    const url = '/api3/company/upgrade_pending';
    const requestBody = { leads_assignment_rules: true };
    const response = await ApiService.put(url, requestBody);
    return response;
  }

  static async getAgentsForWebcontact() {
    const composedURL = '/api3/agent?only_actives=true';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getLeadStatuses() {
    const composedURL = '/api3/contact/leads_status';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getCustomTags() {
    const url = '/api3/contact/custom_tag?grouped=true';
    const response = await ApiService.get(url);
    return response;
  }

  static async getAssignmentReport(filters) {
    const query = summarySearchParams(filters).toString();
    const url = `/api3/webcontact_rules/assignment-report/${
      query ? `?${query}` : ''
    }`;
    const data = await ApiService.get(url);
    return mapSummary(data);
  }

  static async getAssignmentReportDetail(query) {
    const params = detailSearchParams(query).toString();
    const url = `/api3/webcontact_rules/assignment-report/inquiries/?${params}`;
    const data = await ApiService.get(url);
    return mapDetailPage(data);
  }

  static async exportAssignmentReport(query) {
    const params = detailSearchParams(query, { includePage: false }).toString();
    const url = `/api3/webcontact_rules/assignment-report/inquiries/export/?${params}`;
    return ApiService.get(url);
  }
}

export default WebcontactService;
